/* Prakash 10/31/2022 3225736869 added Pagination for Table.
saikrishna 11/03/2022 3225736869 changed the paginationOptions
*/
import {React} from 'react';
// import MaterialTable from "material-table";
import {TablePagination} from '@material-ui/core';
import {tableIcons} from '../../../../../components/TableIcons';
import {useSelector} from 'react-redux';
import {tablePageRows, defaultRows} from '../../../../../constants/ReusableTablePagination';
import GuiTable from '../../../../../components/FormComponents/GuiTable';

export default function RuleGroupTable() {
  const moment = require('moment-timezone');
  const {scheduleData} = useSelector(({addNightJob}) => addNightJob);
  const columns = [
    {
      title: 'Scheduled Date',
      field: 'scheduleDate',
      cellStyle: {maxWidth: 500},
      minWidth: '100px',
      dateSetting: {locale: 'en-US'},
      render: (rowData) => (
        <>
          {rowData?.scheduleDate && moment(rowData.scheduleDate).format('MM/DD/YYYY')}
        </>
      ),
    },
    {
      title: 'Start Date',
      field: 'startDate',
      width: '2%',
      cellStyle: {maxWidth: 500},
      minWidth: '100px',
      dateSetting: {locale: 'en-US'},
      render: (rowData) => (
        <>
          {rowData?.startDate && moment(rowData.startDate).format('MM/DD/YYYY')}
        </>
      ),
    },

    {
      title: 'End Date',
      field: 'endDate',
      width: '2%',
      cellStyle: {maxWidth: 500},
      minWidth: '100px',
      dateSetting: {locale: 'en-US'},
      render: (rowData) => (
        <>
          {rowData?.endDate && moment(rowData.endDate).format('MM/DD/YYYY')}
        </>
      ),
    },
    {
      title: 'Job Name',
      field: 'job.jobName',
      width: '2%',
      cellStyle: {maxWidth: 500},
      minWidth: '100px',
    },
    {
      title: 'Job Status',
      field: 'job.jobStatus',
      width: '2%',
      cellStyle: {maxWidth: 500},
      minWidth: '100px',
    },
  ];
  const scheduleApiData =
  scheduleData && scheduleData.length > 0 ?
    scheduleData.map((item, i) => ({
      ...item,
      id: i,
    })) :
    [];
  return (
    <>
      <div className="custom-table col-md-12 global-filed-table">
        <GuiTable
          title=""
          columns={columns}
          icons={tableIcons}
          data={scheduleApiData}
          textAlign="left"
          options={{
            toolbar: false,
            search: false,
            pageSize: defaultRows,
            pageSizeOptions: tablePageRows,
            emptyRowsWhenPaging: false,
            headerStyle: {
              fontWeight: 'bold',
              fontSize: '0.938rem',
              padding: '16px',
            },
          }}
          components={{

            Pagination: (props) => (
              <TablePagination
                {...props}
                SelectProps={{
                  inputProps: {'aria-label': 'Rows per screen'},
                }}
                labelRowsPerPage={'Rows per screen:'}
                rowsPerPageOptions={tablePageRows}
                onChangeRowsPerPage={(event) => {
                  props.onChangeRowsPerPage(event);
                }}
              />

            ),
          }}
        />
      </div>
    </>
  );
}
